import { AlertFactory } from 'alerts/Alert'
import ModalViewModel from 'infra/ModalViewModel'
import { makeObservable, override } from 'mobx'
import { task } from 'mobx-task'
import Job from 'jobs/Job'
import BusinessProfileStore from 'jobs/info-gathering/business-info/BusinessProfileStore'
import BusinessInfoViewModel from 'jobs/info-gathering/business-info/BusinessInfoViewModel'
import InfoGatheringStore from 'jobs/InfoGatheringStore'
import BusinessProfileEditorViewModel from 'jobs/info-gathering/business-info/editors/BusinessProfileEditorViewModel'

export default class EditBusinessProfileDialogViewModel extends ModalViewModel {
  readonly businessProfileEditorVm = new BusinessProfileEditorViewModel()

  constructor(
    private job: Job,
    private businessInfoVM: BusinessInfoViewModel,
    private businessProfileStore: BusinessProfileStore,
    private infoGatheringStore: InfoGatheringStore,
    private newAlert: AlertFactory,
  ) {
    super()
    makeObservable(this)
  }

  @override
  show() {
    this.businessProfileEditorVm.reset(this.businessInfoVM.profile)
    super.show()
  }

  submit = task.resolved(async () => {
    if (!this.businessProfileEditorVm.validate()) {
      return
    }

    try {
      await this._save()
      this.close()
    } catch (error) {
      this.newAlert().fromError(error).show()
      console.error(error)
    }
  })

  private async _save() {
    const editor = this.businessProfileEditorVm
    const existingProfile = this.businessInfoVM.profile
    const businessInfo = editor.businessInfoVm.toBusinessInfo()
    const contactInfo = editor.contactInfoVm.toContactInfo()

    const saved = existingProfile?.id
      ? await this.businessProfileStore.updateBusinessProfile({
          id: existingProfile.id,
          workspaceId: this.job.workspace.id,
          ownerUserId: this.job.championClient!.member.user.publicId,
          businessInfo,
          contactInfo,
        })
      : await this.businessProfileStore.createBusinessProfile({
          workspaceId: this.job.workspace.id,
          ownerUserId: this.job.championClient!.member.user.publicId,
          businessInfo,
          contactInfo,
        })

    await this.infoGatheringStore.provideSupportingItemBusinessInfo({
      jobId: this.job.id,
      itemId: this.businessInfoVM.businessSupportingItem!.id,
      profileId: saved.id,
      profileVersion: saved.version,
    })
  }
}
